// extracted by mini-css-extract-plugin
export default {"ionContent":"FacilityList_ionContent__LaqwG"};